import React, { FC, useState } from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChillerChangeHistoryRowExpanded from './ChillerChangeHistoryRowExpanded';

import { HistoryItem } from '../../../salesEstimateModules/estimateRebates/model';

interface ChillerChangeHistoryRowProps {
  historyItem?: HistoryItem;
  backgroundColor?: string;
}

const ChillerChangeHistoryRow: FC<ChillerChangeHistoryRowProps> = (props) => {
  let { historyItem, backgroundColor } = props;

  const [fullTableExpanded, setFullTableExpanded] = useState<boolean>(false);

  let line1 = historyItem?.history_item_lines[0];
  let totalItemCount = historyItem?.history_item_lines.length - 1;
  let shouldShowExtras = totalItemCount > 0;
  let hoverStyle = shouldShowExtras ? { cursor: 'pointer' } : {};

  const handleDropdownClicked = () => {
    if (shouldShowExtras) {
      setFullTableExpanded(!fullTableExpanded);
    }
  };

  return (
    <Grid container style={{ backgroundColor: backgroundColor, padding: '6px' }}>
      <Grid item xs={1} onClick={handleDropdownClicked} style={hoverStyle}>
        {shouldShowExtras && <ArrowDropDownIcon />}
      </Grid>
      {fullTableExpanded ? (
        <>
          <Grid item xs={3}>
            <Typography style={{ fontSize: 14 }}>{historyItem?.created_at}</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography style={{ fontSize: 14 }}>{historyItem?.user_name}</Typography>
          </Grid>
        </>
      ) : (
        <>
          <Grid item xs={2}>
            <Typography style={{ fontSize: 14 }}>{historyItem?.created_at}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography style={{ fontSize: 14 }}>{historyItem?.user_name}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography style={{ fontSize: 14 }}>{line1?.field}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography style={{ fontSize: 14 }}>{line1?.before_name}</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography style={{ fontSize: 14 }}>➡ {line1?.after_name}</Typography>
          </Grid>
        </>
      )}
      {shouldShowExtras && !fullTableExpanded && (
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
            <Button
              onClick={handleDropdownClicked}
              size="small"
              endIcon={<ExpandMoreIcon />}
              sx={{
                textTransform: 'none',
                color: 'primary.main',
                '&:hover': {
                  backgroundColor: 'primary.light',
                  color: 'primary.dark',
                },
              }}
            >
              {totalItemCount} more {totalItemCount === 1 ? 'field' : 'fields'}
            </Button>
          </Box>
        </Grid>
      )}
      {fullTableExpanded && (
        <Grid item xs={12} style={{ paddingLeft: 100 }}>
          <ChillerChangeHistoryRowExpanded historyItem={historyItem} backgroundColor={backgroundColor} />
        </Grid>
      )}
    </Grid>
  );
};

export default ChillerChangeHistoryRow;
